import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cm{background:var(--shades-white);}.ssr-plugin'
import '.cd{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b1{max-width:77.5rem;}.ssr-plugin'
import '.cn{justify-content:stretch;}.ssr-plugin'
import '.co{position:sticky;}.ssr-plugin'
import '.cp{top:0px;}.ssr-plugin'
import '.cq{z-index:10;}.ssr-plugin'
import '.cr{padding-block:1rem;}.ssr-plugin'
import '.cs{height:3rem;}.ssr-plugin'
import '.a1{justify-content:space-between;}.ssr-plugin'
import '.ct{flex-wrap:wrap;}.ssr-plugin'
import '.cu{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.az{margin-top:2rem;}.ssr-plugin'
import '.cv{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab i b cm"
      >
        <div className="cd a c i b"
        >
          <div className="b1 a b cn co cp cq cm"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cr cs a a1 c ct"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="cu a b ab az cv b1"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
